import React, {useContext} from "react";
import axios from "axios";
import {installRateLimitInterceptor} from "./helpers/rateLimitToast";

// Obtain the fresh token each time the function is called
function getAccessToken(){
    return JSON.parse(localStorage.getItem('app-reducer'))?.jwt?.replace('"','');
}
window.isLoggedIn = ()=> !!getAccessToken()?.length

function getOrgId(){
    return JSON.parse(sessionStorage.getItem('session-reducer'))?.currentOrg?.id;
}

function getShareLinkCode(){
    return JSON.parse(localStorage.getItem('app-reducer'))?.shareLink?.code;
}

window.clearShareLinkCode = () => {
    try {
        const obj = JSON.parse(localStorage.getItem('app-reducer'))
        obj.shareLink = null
        localStorage.setItem('app-reducer', JSON.stringify(obj))
    } catch(e) {
        console.log('app-reducer key not set')
    }
}

axios.defaults.baseURL = window.Config.apiHost

// Use interceptor to inject the token to requests
axios.interceptors.request.use(request => {
    if(request.url?.match(/vault|localhost|mediagraph\.io|^\//)) {
        const token = getAccessToken();
        if(token) request.headers['Authorization'] = `Bearer ${token}`;

        const orgId = getOrgId()
        if(orgId && !request.headers['OrganizationId']) request.headers['OrganizationId'] = orgId;

        const shareLinkCode = getShareLinkCode()
        if(shareLinkCode) request.headers['ShareLinkCode'] = shareLinkCode;
    }
    return request;
});

// Register this on the shared client at module load so startup requests are
// covered as well as requests made after the React tree has mounted.
installRateLimitInterceptor(axios)

window.api = axios;

export default axios;

window.testInvalidToken = ()=> {
    const data = JSON.parse(localStorage.getItem('app-reducer'))
    data.jwt = 'bad jwt'
    localStorage.setItem('app-reducer', JSON.stringify(data))
}
